import React from 'react';

import Organization from '../../models/organization';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Loading from '../../components/loading';

export function Login() {
    const history = useHistory();
    const { t } = useTranslation();

    const [, loading, , error] = Organization.useApiModel({
        onSuccess: orgas => {
            history.push(`/ticket/O${orgas[0].id}`);
        },
        query: {
            // No need for more
            limit: 1
        }
    });

    if (loading) {
        return <Loading />;
    }

    if (error) {
        return t('ticket.login.organization_retrieval_error');
    }

    return null;
}
